// @owners { team: patients-team }
import { SPACING, type SPACING_STATIC_SIZE } from '@alto/design-library-tokens';
import { ActionSheetV2, Body, LgPadding } from '@alto/design-system';
import React from 'react';

type TransferOutContentProps = {
  topPadding?: SPACING_STATIC_SIZE;
};

export const TransferOutContent = ({ topPadding = SPACING.STATIC.LG }: TransferOutContentProps) => {
  return (
    <LgPadding topPadding={topPadding}>
      <Body>
        Please have your new pharmacy contact us to request the transfer. Once we've received their request, we'll take
        care of the rest.
        {'\n\n'}
        As a reminder, prescriptions may only be transferred if they have refills remaining. Some additional
        restrictions may apply and vary by state.
      </Body>
    </LgPadding>
  );
};

export const TransferOutActionSheet = () => {
  return (
    <ActionSheetV2 title="Transferring medication to another pharmacy">
      <TransferOutContent topPadding={SPACING.STATIC.NONE} />
    </ActionSheetV2>
  );
};
